/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Enable_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Make chats in this project private?" |
*
* @param {Project_Private_Chats_Enable_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_enable_confirm_title = /** @type {((inputs?: Project_Private_Chats_Enable_Confirm_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Enable_Confirm_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chats in diesem Projekt privat machen?")
	return /** @type {LocalizedString} */ ("Make chats in this project private?")
});